import { getToken } from '../funcs/token_funcs';

import { useState, useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

// Dispatchers

import { 
	setAppPage
} from '../store/appStateReducers';

import {
	fetchData,
	setDataIDTokensCue
} from '../store/dataStateReducers';

// Selectors

import { 
	getCurrentPageProps
} from '../store/appStateReducers';

import {
	getDataIDTokensCue
} from '../store/dataStateReducers';

import loading from "../img/loading.gif";


export const LoadingPage = (props) => {

	// ------ fetch data and load login page on fulfilled -----------------

	const dispatch = useDispatch();

	// 1) 
	// - Set the tokens for each data id
	// - Add them to the data_id_tokens_cue_js in dataStateReducers
	const { 
		data_id_a,
		php_scripts_js_a,
		page_to_load,
		page_to_load_props_js
	} = useSelector( (state) => getCurrentPageProps(state) );
	const [trigger_create_tokens_bool, triggerCreateTokens] = useState(true);
	const [data_id_tokens_js, setDataIDTokens] = useState({});
	const [trigger_fetch_data_bool, triggerFetchData] = useState(false);
	useEffect( () => {
		if ( trigger_create_tokens_bool ) {
			
			let data_id_tokens_js = {}
			data_id_a.forEach( (elem) => {
				data_id_tokens_js[elem] = getToken();
			});
			dispatch(
				setDataIDTokensCue({data_id_tokens_cue_js: data_id_tokens_js})
			);
			setDataIDTokens( data_id_tokens_js )
			triggerCreateTokens(false);
			triggerFetchData(true);
		}
	},[
		trigger_create_tokens_bool,
		data_id_a,
		dispatch
	]);

	// 2)
	// - Add the token to each script call
	// - Dispatch the fetchData
	const [trigger_availability_check_bool, triggerAvailabilityCheck] = useState(false);
	useEffect( () => {

		// Do the fetch
		if ( trigger_fetch_data_bool ) {

			php_scripts_js_a.forEach( (elem) => {
				
				let { id, script_uri, data_js } = elem;

				data_js = Object.assign({}, {...data_js, token: data_id_tokens_js[id] });

				dispatch( fetchData({ id, script_uri, data_js }) );

			});

			triggerFetchData(false);
			triggerAvailabilityCheck(true);	

		}


	},[
		trigger_fetch_data_bool,
		php_scripts_js_a,
		data_id_tokens_js,
		dispatch
	]);


	// 3)
	// - Determine whether data_id_tokens_cue_js contains each token?
	// - Is status available?
	// - If so, go to page_to_load
	const data_id_tokens_cue_js = useSelector( (state) => getDataIDTokensCue(state) );
	useEffect( () => {
		if ( trigger_availability_check_bool ) {

			// For each data_id in data_id_tokens_js, check whether it is available
			// in data_id_tokens_cue_js
			// E.g.
			// const data_id_tokens_js = {app_data: "79658912516183", uid_data: "1082710933383222"}
			// const data_id_tokens_cue_js = {
			// 	'79658912516183': {id: "app_data", status: "available"},
			// 	'1082710933383222': {id: "uid_data", status: "available"}
			// }
			// >> 
			// [ true, true ]
			// true

			const data_id_available_bool_a = Object.keys(data_id_tokens_js).map( (k) => {

				let res = false;
				let id = k;
				let token = data_id_tokens_js[id];

				// Does data_id_tokens_cue_js contain this token?
				if ( Object.keys(data_id_tokens_cue_js).includes(token) ) {
					// is the id the same?
					if (data_id_tokens_cue_js[token].id === id) {
						// Is status available?
						if (data_id_tokens_cue_js[token].status === "available") {
							res = true;
						}
					}
				}

				return res;
			});

			const data_id_available_bool = data_id_available_bool_a.includes(false) ? false : true;

			if ( data_id_available_bool ) {
				dispatch( setAppPage( { 
					page: page_to_load,
					props: page_to_load_props_js
				}));
				triggerAvailabilityCheck(false);
			}
		}

	},[
		trigger_availability_check_bool,
		data_id_tokens_js,
		data_id_tokens_cue_js,
		page_to_load,
		page_to_load_props_js,
		dispatch
	]);

	// ----------------------------------------------------------------------

	return (
		<>
			<div>Loading...</div>
			<div>
				<img height={50} src={loading} alt="loading" />
			</div>
		</>
	);
}



// Usage example:

// The page that triggers this page must set up:

// const data_id_a = ['app_data','uid_data'];
// const php_scripts_js_a = [
// 	{
// 		id: "app_data", script_uri: "php/app_data_get.php",
// 		data_js: { 
// 			uid:uid,
// 			app:login_js.data_js.app,
// 			period:login_js.data_js.period
// 		}
// 	},
// 	{
// 		id: "uid_data", script_uri: "php/uid_data_get.php",
// 		data_js: { 
// 			uid:uid,
// 			app:login_js.data_js.app,
// 			period:login_js.data_js.period
// 		}
// 	}					
// ];
// const page_to_load = "appPage";
// const page_to_load_props_js = {};
// dispatch( setAppPage( 
// 	{ 	page: "loadingPage", 
// 		props: { 
// 			data_id_a,
// 			php_scripts_js_a,
// 			page_to_load,
// 			page_to_load_props_js
// 		}
// 	}));
